export default __webpack_public_path__ + "static/media/Governance.24b42ecb.svg";